import React, { useState } from "react";
import Maps from "../../../../common/Maps";

const AminitiesService = ({ vals, hotelName, map }) => {
    const [amenitiesLimit, setamenitiesLimit] = useState(5);
    const [LimitText, setLimitText] = useState("View all Amenities");

    const amenitiesHanlder = (num, type) => {
        if (type !== "View Less") {
            setamenitiesLimit(num);
            setLimitText("View Less");
        } else {
            setamenitiesLimit(5);
            setLimitText("View all Amenities");
        }
    };

    const LimitStyle = {
        height: "350px",
        overflowY: "scroll",
    };

    const NolimitStyle = {
        overflowY: "none",
        height: "auto",
    };
    const getIcon = (aminity) => {
        return aminity.includes("bar") || aminity.includes("Bar")
            ? "assets/hotel_icons/bar.png"
            : aminity.includes("Coffee") || aminity.includes("tea")
            ? "assets/hotel_icons/cafe.png"
            : aminity.includes("elevator")
            ? "assets/hotel_icons/elevator.png"
            : aminity.includes("Wifi") ||
              aminity.includes("wifi") ||
              aminity.includes("WiFi")
            ? "assets/hotel_icons/WiFi.png"
            : aminity.includes("pool") || aminity.includes("Pool")
            ? "assets/hotel_icons/pool.png"
            : aminity.includes("parking") || aminity.includes("Parking")
            ? "assets/hotel_icons/parking.png"
            : aminity.includes("newspapers") ||
              aminity.includes("Newspaper") ||
              aminity.includes("newspaper")
            ? "assets/hotel_icons/newspapers.png"
            : aminity.includes("spa") ||
              aminity.includes("Spa") ||
              aminity.includes("bath")
            ? "assets/hotel_icons/spa.png"
            : aminity.includes("computer") || aminity.includes("computer")
            ? "assets/hotel_icons/Computer.png"
            : aminity.includes("bathroom") || aminity.includes("Bathroom")
            ? "assets/hotel_icons/bathroom.png"
            : aminity.includes("breakfast") || aminity.includes("Breakfast")
            ? "assets/hotel_icons/breakfast.png"
            : aminity.includes("towels") || aminity.includes("Towels")
            ? "assets/hotel_icons/Beach towels.png"
            : aminity.includes("Wedding") || aminity.includes("wedding")
            ? "assets/hotel_icons/Wedding.png"
            : aminity.includes("salon") || aminity.includes("Salon")
            ? "assets/hotel_icons/Hair salon.png"
            : aminity.includes("smoking") || aminity.includes("Smoking")
            ? "assets/hotel_icons/smoking.png"
            : aminity.includes("staff") || aminity.includes("Staff")
            ? "assets/hotel_icons/staff.png"
            : aminity.includes("Wheelchair") || aminity.includes("wheelchair")
            ? "assets/hotel_icons/Wheelchair.png"
            : aminity.includes("Luggage") || aminity.includes("luggage")
            ? "assets/hotel_icons/Luggage.png"
            : aminity.includes("Gift") || aminity.includes("gift")
            ? "assets/hotel_icons/Gift shops.png"
            : aminity.includes("Tennis") || aminity.includes("tennis")
            ? "assets/hotel_icons/Tennis.png"
            : aminity.includes("ATM") || aminity.includes("atm")
            ? "assets/hotel_icons/ATM.png"
            : aminity.includes("Picnic") || aminity.includes("picnic")
            ? "assets/hotel_icons/Picnic.png"
            : aminity.includes("Bicycle") || aminity.includes("bicycle")
            ? "assets/hotel_icons/Bicycle.png"
            : aminity.includes("Beach") || aminity.includes("beach")
            ? "assets/hotel_icons/Beach umbrellas.png"
            : aminity.includes("Safe-deposit") ||
              aminity.includes("safe-deposit")
            ? "assets/hotel_icons/Safe-deposit box.png"
            : aminity.includes("Garden") || aminity.includes("garden")
            ? "assets/hotel_icons/Garden.png"
            : aminity.includes("Parking") || aminity.includes("parking")
            ? "assets/hotel_icons/parking.png"
            : aminity.includes("Meeting") || aminity.includes("meeting")
            ? "assets/hotel_icons/Meeting rooms.png"
            : aminity.includes("charging station") ||
              aminity.includes("Electric car charging")
            ? "assets/hotel_icons/Electric car charging station.png.png"
            : aminity.includes("Laundry") || aminity.includes("laundry")
            ? "assets/hotel_icons/laundry.png"
            : aminity.includes("library") || aminity.includes("Library")
            ? "assets/hotel_icons/library.png"
            : aminity.includes("Terrace") || aminity.includes("terrace")
            ? "assets/hotel_icons/Terrace.png"
            : aminity.includes("24-hour") || aminity.includes("desk")
            ? "assets/hotel_icons/24-hour front desk.png"
            : aminity.includes("Food") || aminity.includes("food")
            ? "assets/hotel_icons/Food.png"
            : aminity.includes("barbecue") || aminity.includes("Barbecue")
            ? "assets/hotel_icons/Barbecue.png"
            : aminity.includes("Smoke-free")
            ? "assets/hotel_icons/No Smoke.png"
            : aminity.includes("fitness") || aminity.includes("Fitness")
            ? "assets/hotel_icons/fitness center.png"
            : "assets/images/red-check.svg";
    };
    return (
        <>
            <div className="col-lg-3 col-md-6 mt-lg-0 mt-5">
                <div
                    className="amenities overflow-auto"
                    style={true === "View Less" ? LimitStyle : NolimitStyle}
                >
                    <div className="get-more-list">
                        <h4>Amenities & Services</h4>
                        <div className="get-more-list amenities-list">
                            {vals?.length > 0 ? (
                                <>
                                    {vals !== undefined &&
                                        vals
                                            .slice(0, amenitiesLimit)
                                            .map((data, i) => (
                                                <div key={i}>
                                                    <div>
                                                        <img
                                                            src={getIcon(
                                                                data.facilities_name
                                                            )}
                                                            alt="red-check"
                                                        />
                                                    </div>
                                                    <p>
                                                        {data.facilities_name}
                                                    </p>
                                                </div>
                                            ))}
                                    <span
                                        onClick={() =>
                                            amenitiesHanlder(
                                                vals.length,
                                                LimitText
                                            )
                                        }
                                        className="view-text"
                                    >
                                        {LimitText}
                                    </span>
                                </>
                            ) : (
                                <img
                                    className="no-aminities upper-aminities"
                                    src="./assets/images/hotel/no-aminities.svg"
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className="hotel-map">
                    {typeof map === typeof "" && (
                        <Maps hotelName={hotelName} latlong={map} />
                    )}
                </div>
            </div>
        </>
    );
};

export default AminitiesService;
